import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq6F+/Onw/eVMKVUszj6K
2T0YOxW1a4/MqhY2sdRRgUoAPokdpxSJVf0Z4zpyXr8fnG932DEbOvQc3HDxWO7I
JSXlrPuqBY2v7eAf4C5SZfWoXDUkhvpWqHqSpwMx1RVBLMHAg7s7KKRO35lpwEtN
544QH/Qk+jbX0a2W7fJySqUT+i8P/R0F2aVNc++Zy1PEpPZdV7RuaffOb7PP0mMK
LnihiL20SecrnvliGAnjsepC5ldTRN/VTB4au0+OUG8PsHVWzALNxnwURK94QcDb
AcPCy5/x/h6JNFqi2BLV682nPqwPacirHNZVf1ZP4h2DZcMRTDbmqNfmmuTw2sPN
mwIDAQAB
-----END PUBLIC KEY-----`;

function generateRandomAESKey(length = 16) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

export function encryptDataHybrid(dataToEncrypt) {
  try {
    // ✅ Step 1: Create a fixed or generated 16-character key (safe for UTF-8)
    const aesKeyString = generateRandomAESKey(); // e.g., "a3Dx7F9bL0tYkQ2z"

    // ✅ Step 2: Convert to WordArray
    const rawKey = CryptoJS.enc.Utf8.parse(aesKeyString);

    // ✅ Step 3: Encrypt JSON payload
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      rawKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const encryptedData = encrypted.toString(); // Base64

    // ✅ Step 4: Encrypt the AES key using RSA
    const rsa = new JSEncrypt();
    rsa.setPublicKey(RSA_PUBLIC_KEY);
    const encryptedKey = rsa.encrypt(aesKeyString); // Now safe

    if (!encryptedKey) throw new Error("RSA encryption failed");

    return {
      encryptedData,
      encryptedKey,
    };
  } catch (err) {
    console.error("🛑 Encryption failed:", err.message);
    return null;
  }
}

